import React, { useEffect, useState } from "react";
import { Table, Row, Col, Space } from "antd";
import { EyeOutlined, DeleteOutlined } from "@ant-design/icons";
import columns from "@staticData/admin/adminConsultationTableColumns";
import moment from "moment-jalaali";
import DeletePurchase from "@general/deletePurchase";

function AdminConsultationTable({
  data,
  onPageChange,
  currentPage,
  onSort,
  loading,
  onOpenDrawer,
  onDataUpdate,
}) {
  const [tableData, setTableData] = useState([]);
  const { getPurchasesCount: count, getPurchases: purchases } = data;
  useEffect(() => {
    const initialTableData = [];

    purchases.map((service) => {
      const { id, user, createdAt, product, reserve } = service;

      initialTableData.push({
        key: id,
        user: user?.name ? user.name : user?.mobile,
        product: product ? product?.name : "-",
        createdAt: moment(createdAt).format("jYYYY/jMM/jDD"),
        consultationDate: reserve?.startAt
          ? moment(reserve?.startAt).format("jYYYY/jMM/jDD")
          : "-",
        consultationTime:
          reserve?.startAt && reserve?.endAt
            ? `از ${moment(reserve?.startAt).format("HH:mm")} تا ${moment(
                reserve?.endAt
              ).format("HH:mm")}`
            : "-",
        place: reserve?.product?.name ? reserve?.product?.name : "-",

        details: (
          <Space>
            <a onClick={() => onOpenDrawer(id)}>
              <EyeOutlined />
            </a>
            |
            <DeletePurchase
              id={id}
              onDeletePurchase={onDataUpdate}
              name={user?.name}
            >
              <a>
                <DeleteOutlined />
              </a>
            </DeletePurchase>
          </Space>
        ),
      });
    });
    setTableData(initialTableData);
  }, [purchases]);

  const onChange = (pagination, filters, sorter, extra) => {
    if (extra.action === "sort") {
      onSort(sorter);
    }
    if (extra.action === "paginate") {
      onPageChange(pagination.current);
    }
  };

  return (
    <>
      <Row>
        <Col span={24}>
          <Table
            columns={columns}
            dataSource={tableData}
            pagination={{
              total: count,
              current: currentPage,
              showSizeChanger: false,
            }}
            onChange={onChange}
            loading={loading}
            scroll={{ x: 800 }}
          />
        </Col>
      </Row>
    </>
  );
}

export default AdminConsultationTable;
